import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Checkbox, FormControlLabel } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import axios from "axios";

import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "./addTeam.scss";

import { AddTeamAction } from "../../../Redux/action/AddTeamAction";
import { VendorProfile as VendorProfileAction } from "../../../Redux/action/VendorProfileAction";
import {
  fetchDepartmentDetails,
  fetchDesignationDetails,
} from "../../../Redux/action/MasterSkillAction";

import { isValidPhoneNumber } from "libphonenumber-js/max";
import { SpinLoader } from "../ImportCandidates";
import ImportantNotes from "../../Common/ImportantNotes";
import BackButton from "../../Common/BackButton/BackButton";

const AddTeam = () => {
  const baseUrl = process.env.REACT_APP_API_PATH;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userResult } = useSelector((state) => state.Auth);
  const loading = useSelector((state) => state.AddTeam.loading);
  const AllDeparmentList = useSelector(
    (state) => state?.MasterTableDetails?.department?.content
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );

  const [dialCode, setDialCode] = useState("");
  const [localPhone, setLocalPhone] = useState("");
  const [countryCode, setCountryCode] = useState('in');
  const [isBillable, setIsBillable] = useState(true);
  const [department, setDepartment] = useState("");
  const [errors, setErrors] = useState({});
  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userType: "CANDIDATE",
    currentDesignation: "",
    reportingManager: "",
    panCardNumber: "",
    aadharCardNumber: "",
    aadharCardNumber2: "",
    validity: "",
    mobile: "",
    availableForWork: false,
  });

  const {
    firstName,
    lastName,
    email,
    currentDesignation,
    reportingManager,
    mobile,
    panCardNumber,
    aadharCardNumber,
    aadharCardNumber2,
    availableForWork,
  } = state;

  const vendorId = userResult?.vendorid;
  const isIndian = countryCode === "in";

  // Form data to send
  const content = {
    vendorId,
    firstName,
    lastName,
    email,
    currentDesignation,
    reportingManager,
    isBillable,
    mobile:localPhone,
    panCardNumber,
    aadharCardNumber,
    department,
    countryCode,
    availableForWork,
    dialCode
  };

  useEffect(() => {
    dispatch(fetchDepartmentDetails());
    dispatch(fetchDesignationDetails());
    dispatch(VendorProfileAction());
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    if (!isBillable) setState((prev) => ({ ...prev, availableForWork: false }));
  }, [isBillable]);

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    setState((prev) => ({
      ...prev,
      [name]: name === "panCardNumber" ? updatedValue.toUpperCase() : updatedValue,
    }));
  };

  const validatePan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  const handleAccept = async (data) => {
    const style = document.createElement("style");
    style.innerHTML = `
      .custom-confirm-button { background-color: #286a94 !important; color: white; }
      .custom-title { border-bottom: 0.5px solid #adadad; color: #286a94 !important; padding-bottom: 10px; }
      .msg-paragraph { margin-top:10px; }
    `;
    document.head.appendChild(style);

    const htmlContent = `
      <div>
        <div class="custom-paragraph">Are you sure you want to send request?</div>
        <div class="msg-paragraph">The candidate you are trying to add already has an individual account on EBench.</div>
      </div>
    `;

    const result = await Swal.fire({
      title: "Send Invitation",
      html: htmlContent,
      showCancelButton: true,
      confirmButtonText: "Send",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
    });

    if (result.isConfirmed) {
      try {
        await axios.post(`${baseUrl}/ebench/send_request`, data);
        toast.success("Invitation sent successfully");
        setTimeout(() => navigate("/team-list"), 1500);
      } catch {
        Swal.fire("Error", "There was an error sending the invitation", "error");
      }
    }
  };

const handleSubmit = (e) => {
  e.preventDefault();

  const rawNumber = (localPhone || state.mobile || "").toString().trim();
  const cleanedNumber = rawNumber.replace(/\D/g, "");
  const localNumber = dialCode && cleanedNumber.startsWith(dialCode)
    ? cleanedNumber.slice(dialCode.length)
    : cleanedNumber;

  console.log("localNumber", localNumber, "dialCode", dialCode, "raw", rawNumber);

  if (!localNumber) {
    toast.error("Please enter your phone number");
    return;
  }

  const isIndianNumber = dialCode === "91" && /^[6-9]\d{9}$/.test(localNumber);
  const isInternationalNumber = dialCode !== "91" && /^\d{7,15}$/.test(localNumber);

  if (!isIndianNumber && !isInternationalNumber) {
    const message =
      dialCode === "91"
        ? "Please enter a valid 10-digit Indian mobile number"
        : "Please enter a valid international phone number (7–15 digits)";
    toast.error(message);
    return;
  }

  if (isIndian && !validatePan(panCardNumber)) {
    return toast.error("Invalid PAN card number. Format: XXXXX9999X");
  }

  if (isIndian && (aadharCardNumber.length !== 12 || aadharCardNumber2.length !== 12)) {
    return toast.error("Aadhaar Number must be 12 digits");
  }

  if (aadharCardNumber !== aadharCardNumber2) {
    return toast.error(`${isIndian ? "Aadhaar" : "Government ID"} numbers do not match`);
  }

  console.log("Submitting content:", content);
  dispatch(AddTeamAction(content, navigate))
    .then((res) => {
      if (res?.data?.statusCodeValue === 400) handleAccept(content);
    })
    .catch((error) => {
      if (error?.response?.data?.status?.message === "Candidate has a personal account") {
        handleAccept(content);
      } else {
       console.log("Error adding team member");
      }
    });
};


  const handleDropdownChange = (e) => setDepartment(e.target.value);
  const handleCopy = (e) => e.preventDefault();

  return (
    <div>
      <ToastContainer />
      <div className="d-flex flex-column flex-md-row gap-4 container mt-4" style={{ paddingBottom: "10px" }}>
        <div className="common_wrapper mt-0">
          <BackButton />
          <div className="can_prof_container">
            <div className="card can_prof_main">
              <div className="card-header prof_header d-flex justify-content-between">
                Add Team Member
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Billable / Non-Billable */}
                  <div className="col-12 col-lg-6 mb-3">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="billable"
                        name="isbillable"
                        checked={isBillable}
                        onChange={() => setIsBillable(true)}
                      />
                      <label className="form-check-label" htmlFor="billable">Billable</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="non-billable"
                        name="isbillable"
                        checked={!isBillable}
                        onChange={() => setIsBillable(false)}
                      />
                      <label className="form-check-label" htmlFor="non-billable">Non-Billable</label>
                    </div>
                  </div>

                  {/* First and Last Name */}
                  <div className="row gx-3 mb-3">
                    {["firstName", "lastName"].map((field, idx) => (
                      <div key={field} className="col-12 col-lg-6">
                        <label className="small mb-1">
                          {field === "firstName" ? "First Name" : "Last Name"}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name={field}
                          placeholder={`Enter your ${field === "firstName" ? "first" : "last"} name`}
                          value={state[field]}
                          required
                          minLength={2}
                          maxLength={50}
                          pattern="^[A-Za-z]+$"
                          title="Only alphabetic characters allowed"
                          onChange={handleInputChange}
                        />
                        {errors[field] && (
                          <div className="text-danger small mt-1">{errors[field]}</div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Email + PAN/GovTaxID */}
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">Email <span style={{ color: "red" }}>*</span></label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">
                        {isIndian ? "PAN Number" : "Government Tax ID"} <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="panCardNumber"
                        placeholder={`Enter your ${isIndian ? "PAN Number" : "Government Tax ID"}`}
                        value={panCardNumber}
                        onChange={handleInputChange}
                        maxLength={isIndian ? 10 : undefined}
                        required
                      />
                    </div>
                  </div>

                  {/* Designation + Government ID */}
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">Current Designation <span style={{ color: "red" }}>*</span></label>
                      <select
                        className="form-select"
                        name="currentDesignation"
                        value={currentDesignation}
                        required
                        onChange={handleInputChange}
                      >
                        <option value="" disabled hidden>Select designation</option>
                        {AllDesignationList?.map((d) => (
                          <option key={d?.designationId} value={d?.designation}>
                            {d?.designation}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">
                        {isIndian ? "Aadhaar Number" : "Government ID"} <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        name="aadharCardNumber"
                        value={aadharCardNumber}
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "aadharCardNumber",
                              value: e.target.value.replace(/\D/g, ""),
                            },
                          })
                        }
                        placeholder={`Enter your ${isIndian ? "Aadhaar" : "Government ID"}`}
                        maxLength={12}
                        required
                        onCopy={handleCopy}
                      />
                    </div>
                  </div>

                  {/* Reporting Manager + Confirm ID */}
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">Reporting Manager</label>
                      <input
                        className="form-control"
                        type="text"
                        name="reportingManager"
                        value={reportingManager}
                        placeholder="Enter your reporting manager"
                        onChange={handleInputChange}
                        pattern="^[A-Za-z ]+$"
                        minLength={2}
                        maxLength={50}
                      />
                    </div>
                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">
                        Confirm {isIndian ? "Aadhaar Number" : "Government ID"}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        name="aadharCardNumber2"
                        value={aadharCardNumber2}
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "aadharCardNumber2",
                              value: e.target.value.replace(/\D/g, ""),
                            },
                          })
                        }
                        placeholder={`Confirm your ${isIndian ? "Aadhaar" : "Government ID"}`}
                        maxLength={12}
                        required
                      />
                      {errors.aadharCardNumber && (
                        <div className="text-danger small mt-1">
                          {errors.aadharCardNumber}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Department + Mobile */}
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">Department <span style={{ color: "red" }}>*</span></label>
                      <select
                        className="form-select"
                        value={department}
                        required
                        onChange={handleDropdownChange}
                      >
                        <option value="" disabled hidden>Select department</option>
                        {AllDeparmentList?.map((d) => (
                          <option key={d?.departmentId} value={d?.departmentName}>
                            {d?.departmentName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 col-lg-6">
                      <label className="small mb-1">Mobile <span style={{ color: "red" }}>*</span></label>
                      <PhoneInput
                        country={countryCode || "in"}
                        onChange={(value, countryData) => {
                          const dial = countryData?.dialCode || "";
                          const code = countryData?.countryCode?.toLowerCase() || "in";
                          setDialCode(dial);
                          setCountryCode(code);
                          const cleaned = value.replace(/\D/g, "");
                          const local = cleaned.startsWith(dial)
                            ? cleaned.slice(dial.length)
                            : cleaned;
                          setLocalPhone(local);
                        }}
                        placeholder="Phone Number"
                        enableSearch
                        inputClass="custom-phone-input"
                        buttonClass="custom-flag-btn"
                        dropdownClass="custom-country-dropdown"
                      />
                      {/* <input
                        type="number"
                        className="form-control mt-2"
                        placeholder="Enter your mobile number"
                        required
                        name="mobile"
                        value={mobile}
                        onChange={(e) =>
                          setState((prev) => ({
                            ...prev,
                            mobile: e.target.value.slice(0, 10),
                          }))
                        }
                      /> */}
                    </div>
                  </div>

                  {isBillable && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={availableForWork}
                          onChange={handleInputChange}
                          name="availableForWork"
                        />
                      }
                      label="Open For Market (Availability Status)"
                    />
                  )}

                  <button className="can_update_prof_btn add_skill_btn d-flex" disabled={loading} type="submit">
                    {loading ? <SpinLoader /> : "Add Member"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <ImportantNotes />
      </div>
    </div>
  );
};

export default AddTeam;
